/**
 * Get
 * @param {String} key
 * @returns {String|null}
 */
function getToken(key = 'dms_admin_access_token') {
  let token = null
  try {
    token = localStorage.getItem(key)
  } catch (ex) {
    token = null
  }
  return token
}
/**
 * State function
 */
export default function() {
  return {
    accessToken: getToken('dms_admin_access_token'),
    refreshToken: getToken('dms_admin_refresh_token'),
    user: {},
    auth_tokens: {},
    isTokenRefreshing: false,
    refreshingCall: undefined,
    accountId: null,
    defaultProfile: {
      first_name: '',
      last_name: '',
      middle_name: '',
      birthdate: '',
      gender: null,
      email: '',
      phone: '',
      image: '',
      confirmed_email: true,
      confirmed_phone: false
    },
    profile: {},

    /** Available values:
     * - ok
     * - error
     * - notSignedIn
     */
    routeStatus: '',

    editorBaseConfig: {
      theme: 'modern',
      menubar: false,
      plugins: [
        'advlist autolink lists link image charmap print preview anchor textcolor',
        'searchreplace visualblocks code fullscreen'
      ],
      toolbar:
        'formatselect | fontselect | fontsizeselect | bold italic strikethrough forecolor backcolor | alignleft aligncenter alignright alignjustify  | numlist bullist | hr pagebreak nonbreaking | outdent indent  | removeformat fullscreen',
      language_url: '/static/tinymce_langs/ru.js',
      language: 'ru'
    },
    editorApiKey: 't19z3fx7xwcvas9m8ogdwjg110vmc8hbtnig4u88il6yve2r'
  }
}



// WEBPACK FOOTER //
// ./src/store/app/state.js